/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SampleModule' store object.
 * @namespace SampleModuleSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASampleModule';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SampleModuleSelectors
   */
  static fetchOnlineCategories = state =>
    state[selectors.moduleIdentifier].fetchOnlineCategories.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SampleModuleSelectors
   */
  static isFetchingFetchOnlineCategories = state =>
    state[selectors.moduleIdentifier].isFetchingFetchOnlineCategories.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SampleModuleSelectors
   */
  static fetchOnlineCategoriesError = state =>
    state[selectors.moduleIdentifier].fetchOnlineCategoriesError.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SampleModuleSelectors
   */
  static isFetchingPostApplicationForm = state =>
    state[selectors.moduleIdentifier].isFetchingPostApplicationForm.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SampleModuleSelectors
   */
  static createApplicationFormError = state =>
    state[selectors.moduleIdentifier].createApplicationFormError.payload;

  /**
   * Selects the data from the store
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SampleModuleSelectors
   */
  static selectedApplicationType = state =>
    state[selectors.moduleIdentifier].selectedApplicationType.payload;
}
